<template>
  <el-dialog
    width="680px"
    :visible.sync="modelValue.visibleAddDialog"
    custom-class="repair-create"
    title="添加修缮记录"
  >
    <!-- <div class="found-title">添加巡查记录</div> -->
    <step-list :stepList="stepList" :active="modelValue.active" />
    <ganged-control
      :limitEditSingle="limitRepairAdd"
      v-bind:detailData.sync="repairRecord"
      v-model="modelValue"
      :activeLength="3"
      @onSaveAllClick="$emit('onSaveAllClick')"
      @onCancelEdit="$emit('onCancelEdit')"
      @onSavePart="$emit('onSavePart')"
    >
      <component
        v-bind:is="repairComponent"
        v-bind:visibleEdit.sync="modelValue.visibleEdit"
        v-bind:repairRecord.sync="repairRecord"
      ></component>
    </ganged-control>
  </el-dialog>
</template>

<script>
const repair_map = new Map([
  [1, { component: 'RepairCreateBase' }],
  [2, { component: 'repairCreateUploadVue' }],
  [3, { component: 'repairCreateBeforeVue' }],
  [4, { component: 'repairCreateAfterVue' }],
  [5, { component: 'repairCreateAfterVue' }]
]);
import { modelMixin } from '../../assets/js/mixins/model';
import editHeaderVue from '../layout/edit-header.vue';
import stepList from '../layout/step-list.vue';
import repairCreateAfterVue from './repair-create-after.vue';
import RepairCreateBase from './repair-create-base.vue';
import repairCreateUploadVue from './repair-create-upload.vue';
import repairCreateBeforeVue from './repair-create-before.vue';
import GangedControl from '../layout/ganged-control.vue';
import { mapState } from 'vuex';
import { roleJudge } from '../../config/roleJudge';
export default {
  components: {
    stepList,
    RepairCreateBase,
    editHeaderVue,
    repairCreateUploadVue,
    repairCreateBeforeVue,
    repairCreateAfterVue,
    GangedControl
  },
  props: {
    repairRecord: {
      type: Object,
      default: () => ({})
    }
  },
  mixins: [modelMixin],
  data() {
    return {
      active: 0,
      stepList: ['基本信息', '文件上传', '修缮前照片', '竣工后照片'],
      visibleEdit: false
    };
  },

  computed: {
    ...mapState('login', ['authorizationLimit']),

    repairComponent() {
      const { component } = repair_map.get(this.modelValue.active + 1);
      return component;
    },
    limitRepairAdd() {
      return roleJudge(this.authorizationLimit, 1, 2, 3, 4);
    }
  },

  methods: {
    handleSaveReportInfo() {},
    handleCancelReportInfo() {}
  }
};
</script>

<style lang="scss">
.repair-create {
  .edit-header {
    border: 0px !important;
  }
  .el-dialog {
    &__header {
      height: 44px;
      line-height: 44px;
      background-color: $color-primary;
      padding: 0;
    }
    &__title {
      color: #fff;
      margin-left: 10px;
    }
    &__body {
      padding: 28px 24px;
      overflow-y: auto;
      height: 785px;
      padding-bottom: 50px;
    }
    &__headerbtn {
      display: flex;
      font-size: 30px;
      color: #fff;
      top: -5px;
      right: -40px;
    }
    &__close {
      color: #fff;
    }
  }
  .found {
    &-title {
      position: absolute;
      top: 0;
      left: 0;
      color: #fff;
      line-height: 44px;
      width: 100%;
      height: 44px;
      background-color: $color-primary;
    }
  }
}
</style>
